<template>
    <div class='ListContainer'>
        <q-table class='List'
            :dark='false'
            :data='qtableData'
            :columns='qtableColumns'
            virtual-scroll
            row-key='id'
            :virtual-scroll-item-size="48"
            :pagination="qtablePagination"
            @virtual-scroll="handleQtableScroll"
            :loading='qtableLoading'
            :selected.sync="report.selectedRows"
            :selected-rows-label="getSelectedString"
            :selection="report.selectionMode"
            @selection="handleQtableSelect"
            :style="'height: ' + qtableHeight"
            ref="table"
        >
            <template v-if="this.$props.listType == 'Receipt'" v-slot:header-cell-name="props">
                 <!-- <q-th class='text-left'>
                     <p>{{ props.col.name }}</p>
                     <p>Vendor Location</p>
                 </q-th> -->
            </template>
            <template v-slot:header="props">
                <q-tr :props="props">
                    <q-th v-if='report.selectionMode != "none"'><q-checkbox v-model="props.selected" /></q-th>
                    <q-th v-for="(col, index) in props.cols" :key="col.name" v-if="col.name != 'origin'" :props="props" class='text-left'>
                        <ListHeaderCell  :columnData='col.columnData':isLast="index === props.cols.length - 1" @update-sort='updateSort' @update-selected-facet='updateSelectedFacet'/>
                    </q-th>
                </q-tr>
            </template>
            
             <template v-if="this.$props.listType == 'Receipt'" v-slot:body-cell-name="props">
                 <q-td class='text-left'>
                     <p>{{ props.row.name }}</p>
                     <p>{{ props.row.origin }}</p>
                 </q-td> 
            </template> 
             <template v-if="this.$props.listType == 'Receipt'" v-slot:body-cell-origin="props">
            </template>
            <template v-slot:bottom>
                <span> {{ format(report.results, 'int') }} records matched</span>
                <span v-if='rowsSelected === 1'>{{rowsSelected}} row selected</span>
                <span v-if='rowsSelected > 1'>{{rowsSelected}} rows selected</span>
            </template>
            <template v-slot:top>
                <ListTools
                    :textFilter='report.textFilter'
                    :tableIsLoading='report.loading'
                    :reportButtons='report.reportButtons'
                    @update-text-filter='updateTextFilter'
                    @report-button-clicked='handleReportButtonClick'
                    :reportTitle='report.title'
                >
                    <template v-slot:buttons>
                        <slot name='buttons'></slot>
                    </template>
                </ListTools>
            </template>
            <template v-slot:body-cell-rowActions="props">
                <q-td :props="props">
                    <q-btn-dropdown flat dense no-icon-animation 
                        :menu-offset='[10,15]' 
                        :target='true' 
                        menu-self='top right' 
                        menu-anchor='top left' 
                        :ripple='false' 
                        :icon-right="matMoreVert" 
                        :dropdownIcon="matMoreVert"
                        @show='handleMenuPop'
                        @hide='handleMenuHide'
                        >
                            <q-item
                                v-for='(action, idx) in report.rowActions'
                                :key='props.row.id + idx'
                                clickable
                                v-close-popup
                                @click="handleRowAction({action: action.action, sku: props.row.sku })">
                                <q-item-section>
                                    <q-item-label>{{ action.label }}</q-item-label>
                                    <q-icon v-if='action.label == "Delete"' :name='biTrashFill' />
                                </q-item-section>
                            </q-item>
                    </q-btn-dropdown>
                </q-td> 
        </template>
        </q-table>
        <div class='row' id='TableTools' >
            <div class='col-11' id='ToolSection'>
                <div class='row'></div>
                    <div class='col-3 AddItemToBox' v-if="whichList == 'Item'">
                        <Select
                            label='Add Item To Box'
                            store="BuyTracker/ItemCreate"
                            name='selectedBox'
                            :options='boxOptions'
                            :disabled='false'
                        />
                    </div>
                    <div class='col-2 AddToBox' v-if="whichList == 'Item'">
                        <Button 
                            CTA='Add To Box'
                            type='primary'
                            btnClass='BtnAdd'
                            btnAction='AddToBox'
                            btnTarget='addto-box'
                            @addto-box='addtoBox'
                        />
                    </div>
                    <div class='col-3 Spacer'>&nbsp;</div>
                    <div class='col-5 Spacer' v-if="whichList == 'Receipt'">&nbsp;</div>
                    <div v-if='exportsAllowed == true' class='col-4 ExportButton'>
                        <Button 
                            :CTA='exportCta'
                            btnClass='BtnSave'
                            btnAction='ExportItems'
                            btnTarget='export-items'
                            @export-items='exportItems'
                        />
                    </div>
                </div>
            </div>
            
        </div>
       
        
    </div>
</template>
<script>
    import { QTable, QTr, QTh, scroll } from 'quasar'
    import SortedAscIcon from '../../icons/SortedAscIcon.vue';
    import SortedDescIcon from '../../icons/SortedDescIcon.vue';
    import FunnelIcon from '../../icons/FunnelIcon.vue';
    import ThreeDotsVerticalIcon from '../../icons/ThreeDotsVerticalIcon.vue';
    import ListHeaderCell from './ListHeaderCell.vue'
    import ListTools from './ListTools.vue'
    import Formatter from '../../../js/format.js';
    import { matMoreVert } from '@quasar/extras/material-icons'
    import { biTrashFill } from '@quasar/extras/bootstrap-icons'
    import { exportFile } from 'quasar'
    import Button from '../../core/form/Button.vue';
    import Select from '../../core/form/Select.vue';
    function wrapCsvValue (val, formatFn) {
        let formatted = formatFn !== void 0
            ? formatFn(val)
            : val

        formatted = formatted === void 0 || formatted === null
            ? ''
            : String(formatted)

        formatted = formatted.split('"').join('""')
        /**
        * Excel accepts \n and \r in strings, but some other CSV parsers do not
        * Uncomment the next two lines to escape new lines
        */
        // .split('\n').join('\\n')
        // .split('\r').join('\\r')

        return `"${formatted}"`
    }

    export default {
        name: 'List',
        components: {
            QTable,
            QTr,
            QTh,
            scroll,
            ListHeaderCell,
            ListTools,
            SortedAscIcon,
            SortedDescIcon,
            FunnelIcon,
            ThreeDotsVerticalIcon,
            matMoreVert,
            biTrashFill,
            Button,
            Select
        },
        props: ['initialReportState', 'listType', 'allowExport'],
        data() {
            return{
                report: {
                    model: this.$props.initialReportState.model,
                    columns: this.$props.initialReportState.columns || {},
                    availableColumns: [],
                    textFilter: this.$props.initialReportState.textFilter || '',
                    rows: this.$props.initialReportState.rows || 200,
                    page: this.$props.initialReportState.page || 0,
                    data: [],
                    results: null,
                    selectedFacets: this.$props.initialReportState.selectedFacets || [],
                    sorts: this.$props.initialReportState.sorts || {},
                    updated: this.$props.initialReportState.updated,
                    modified: false,
                    loading: false,
                    selectedRows: this.$props.initialReportState.selectedRows || [],
                    selectionMode: this.$props.initialReportState.selectionMode || 'none',
                    allSelected: false,
                    height: this.$props.initialReportState.height || "calc(100vh - 190px)",
                    title: this.$props.initialReportState.title || 'Untitled Report',
                    reportButtons: this.$props.initialReportState.reportButtons || [],
                    rowActions: this.$props.initialReportState.rowActions || []
                },
                scrollInfo: {},
                exportsAllowed: this.$props.allowExport,
                boxOptions: [],
                whichList: this.$props.listType
            }
            
        },
        computed: {
            qtableData(){
                if(this.report.rowActions.length > 0) return this.report.data.map(row => { return {...row, ...{reportActions: true }}})
                else return this.report.data
            },
            qtableColumns(){
                var columns = Object.values(this.report.columns).map(col => { return {
                    name: col.name,
                    field: col.name,
                    columnData: col
                }});
                columns = [{
                    name: 'image',
                    field: 'image',
                    columnData: {
                            dataType: 'image',
                            displayName: 'image',
                            facets: [],
                            metrics: [],
                            name: 'image',
                            rangeGap: null,
                            sort: null,
                            sortPriority: 0,
                            sortable: 0
                        },
                }, ...columns]
                if(this.report.rowActions.length > 0){
                    columns.push({
                        name: 'rowActions',
                        field: 'rowActions',
                        columnData: {
                            dataType: 'actions',
                            displayName: '',
                            facets: [],
                            metrics: [],
                            name: 'rowActions',
                            rangeGap: null,
                            sort: null,
                            sortPriority: 0,
                            sortable: 0
                        }
                    })
                };
                
                return columns
            },
            qtablePagination(){
                return {
                    rowsPerPage: this.report.rows,
                    rowsNumber: this.report.results,
                    page: this.report.page,
                    sortBy: 'desc',
                    descending: false
                }
            },
            qtableLoading(){
                return this.report.loading
            },
            qtableHeight(){
                return this.report.height
            },
            rowsSelected(){
                return this.report.selectedRows.length
            },
            exportCta(){
                return (this.report.selectedRows.length > 0)  ? 'Export Selected '+ this.$props.listType+'s to CSV' : 'Export '+ this.$props.listType+'s to CSV'
            }
        },
        created(){
            this.matMoreVert = matMoreVert;
            this.biTrashFill = biTrashFill;
            this.getBoxOptions();
        },
        mounted(){
            this.updateReport();
            this.refs = this.$refs;
        },
        methods: {
            handleMenuPop(e){
                document.getElementsByClassName('q-table__middle')[0].style.overflow = 'hidden';
                window.scrollBy(0, 1)  //realigns popup box -jm
                window.scrollBy(0, -1)
            },
            handleMenuHide(e){
                document.getElementsByClassName('q-table__middle')[0].style.overflow = 'auto';
            },
            parseReportForSend(pageOnly = false) {
                var parsed = {...this.report}
                delete parsed.availableColumns
                delete parsed.data
                delete parsed.results
                delete parsed.updated
                delete parsed.modified
                parsed.pageOnly = pageOnly
                return parsed
            },
            parseReportResponse(response, pageOnly){
                //console.log('parsed report response is: ' + JSON.stringify(response.selectedColumns));
                var formattedData = Formatter.formatReportRows(response.data, pageOnly ? this.report.columns : response.selectedColumns,)
                this.report = {...this.report, ...{
                    availableColumns: pageOnly ? this.report.availableColumns : response.availableColumns,
                    columns: pageOnly ? this.report.columns : response.selectedColumns,
                    data: pageOnly ? this.report.data.concat(formattedData) : formattedData,
                    textFilter: response.textFilter,
                    rows: response.rows,
                    page: response.page,
                    results: response.results,
                    selectedFacets: response.selectedFacets,
                    sorts: response.sorts,
                    selectedRows: this.report.allSelected ? this.report.data.concat(response.data) : this.report.selectedRows
                }}
                //console.log('report data sort is: ' + JSON.stringify(this.report.columns));

            },
            updateReportAttribute(update, post = true){
                var pageOnly = (Object.values(update).length == 1 && 'page' in update)
                if(!pageOnly) update = {...update, ...{page: 1}}
                this.report = {...this.report, ...update }
                if(post) this.updateReport(pageOnly)
            },
            updateReport(pageOnly){
                this.updateReportAttribute({loading: true}, false)
                this.$api.post('/api/reporting/json', this.parseReportForSend(pageOnly))
                    .then((response) => this.parseReportResponse(response, pageOnly))
                    .catch((error) => console.log(error))
                    .finally(() => this.updateReportAttribute({loading: false}, false))
            },
            saveReport(){
                this.$store.dispatch('Reporting/saveReport', this.parseReportForSend());
                this.modified = false;
            },
            updateSort(payload){
                if(payload.append) var newSort = {...this.report.sorts};
                else var newSort = {};
                newSort[payload.column] = {direction: payload.direction, order: Object.keys(newSort).length}
                //console.log('Sorting the data: '+ JSON.stringify(newSort));
                this.updateReportAttribute({sorts: newSort}, true)
            },
            updateSelectedFacet(payload){
                var newSelectedFacets = [...this.report.selectedFacets];
                var match = newSelectedFacets.findIndex(facet => facet.column == payload.column && facet.value == payload.value);
                if(payload.selected){
                    if(match != -1) return;
                    newSelectedFacets.push({column: payload.column, value: payload.value});
                }else{
                    if(!match == -1) return;
                    newSelectedFacets.splice(match, 1);
                }
                this.updateReportAttribute({selectedFacets: newSelectedFacets}, true);
            },
            updateTextFilter(payload){
                this.updateReportAttribute({textFilter: payload || ''}, true)
            },
            handleQtableScroll({to, ref}){
                const lastIndex = this.report.data.length - 1
                if (this.report.loading !== true && (this.report.page + 1) < Math.ceil(this.report.results / this.report.rows) && to >= (this.report.data.length - 100)) {
                    this.updateReportAttribute({page: this.report.page + 1}, true);
                }
            },
            handleQtableSelect({ rows, added, evt }){
                if(rows.length == this.report.data.length) this.updateReportAttribute({allSelected: added}, false)
            },
            format(value, datatype){
                return value ? Formatter.format(value, datatype) : ''
            },
            handleReportButtonClick(payload){
                this.$emit(payload.action, this.report.selectedRows)
            },
            handleRowAction(payload){
                console.log(payload.sku)
                console.log(JSON.stringify(payload.action))
                this.$emit(payload.action, {sku: payload.sku})
            },
            getSelectedString () {
                return this.report.selectedRows.length === 0 ? '' : `${this.report.selectedRows.length} record${this.report.selectedRows.length > 1 ? 's' : ''} selected of ${this.data.length}`
            },
            addImages(){
                return '/images/no-listing.PNG'
            },
            exportItems () {

                let dataToExport =  this.$refs.table.someRowsSelected ? this.report.selectedRows : this.qtableData
                // naive encoding to csv format
                const content = [ this.qtableColumns.map(col => wrapCsvValue(col.label)) ].concat(
                    dataToExport.map(row => this.qtableColumns.map(col => wrapCsvValue(
                    typeof col.field === 'function'
                        ? col.field(row)
                        : row[col.field === void 0 ? col.name : col.field],
                    col.format
                    )).join(','))
                ).join('\r\n')

                const status = exportFile(
                    'table-export.csv',
                    content,
                    'text/csv'
                )

                if (status !== true) {
                    this.$q.notify({
                    message: 'Browser denied file download...',
                    color: 'negative',
                    icon: 'warning'
                    })
                }
            },
            addtoBox(value){
                console.log('Adding to Box - '+ value); //TODO - Add To Box
            },
            getBoxOptions() {
                this.$api.get('/api/faker', {}).then(response => {
                    this.boxOptions = [
                        {value: 1, label: 'box 1'},
                        {value: 2, label: 'box 2'},
                        {value: 1, label: 'box 3'},
                        {value: 2, label: 'box 4'}
                    ]
                });
            },
        },
       
    }
</script>

<style lang="scss">
    @use '~quasar/src/css/index.sass';
    //@import '~material-design-icons/iconfont/material-icons.css';
</style>
